import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Caption.module.css';

const bindClasses = classNameBind.bind(styles);

const Caption = ({
  children,
  noSelect,
  subdued,
  subduedDarkBg,
  cutText,
  dataId,
}) => (
  <p
    className={bindClasses('caption', { 'no-select': noSelect, subdued, subduedDarkBg, cutText })}
    data-ppuc-id={dataId}
  >
    {children}
  </p>
);

Caption.defaultProps = {
  noSelect: false,
  subdued: false,
  subduedDarkBg: false,
  cutText: false,
  dataId: 'Caption',
};

export default Caption;
